/* globals Ajax, lp, localStorage */
var jQuery = require('jquery');
var _ = require('lodash');

var ubBanzai = require('ub/control/banzai-features.js');
var lightboxFactory = require('ub/lp/editor/lightbox-factory');
var _safeGet = require('ub/utils').safeGet;
var endpoints = require('ub/config/endpoints').default;
var fontMigrator = require('ub/fonts/pom-updater/migrator-utils').default;

/* TODO
 Wouldnt mind looking at the copy and paste commands in separate contextual blocks
 And a block that wires the 2 commands together
 */
var AlertDialog = require('ub/ui/alert-dialog');

var _internalLightboxesEnabled = function(page) {
  return page.getConfigValue('allowInternalLightboxes');
};

var _getAssetUUIDs = function(jso) {
  var assetAccessors = [];

  if (jso.type === 'lp-pom-image') {
    assetAccessors = [
      'content.asset'
    ];

  } else if (_.contains(['lp-pom-box', 'lp-pom-text', 'lp-pom-block'], jso.type)) {
    assetAccessors = [
      'style.background.image',
      'breakpoints.mobile.style.background'
    ];

  } else if (jso.type === 'lp-pom-button') {
    assetAccessors = [
      'style.up.image',
      'style.hover.image',
      'style.active.image',
      'breakpoints.mobile.style.up.image',
      'breakpoints.mobile.style.hover.image',
      'breakpoints.mobile.style.active.image',
      'action.asset'
    ];
  }

  return _(assetAccessors)
    .map(function(accessor) {
      return _safeGet(jso, accessor + '.uuid');
    })
    .reject(_.isUndefined)
    .value();
};

var _toClipboardFormat = function(elm, clipboardData, editor) {
  // Serializes an element and all of its children for copying.
  // Also builds an array of `assetUUIDs` and hash of `lightboxes` within `clipboardData`.

  var jso = _.clone(elm.toJSO());

  jso.id = null;
  jso.containerId = null;
  jso.children = [];

  // Recursively add child elements
  var childElements = elm.selection || elm.childElements;
  jso.children = _.map(childElements, function(child) {
    return _toClipboardFormat(child, clipboardData, editor);
  });

  clipboardData.assetUUIDs = clipboardData.assetUUIDs.concat(_getAssetUUIDs(jso));

  // Add form confirmation dialog
  if (elm.type === 'lp-pom-form') {
    var confirmationPage = editor.findPagesUsedAs('form_confirmation')[0];
    jso.confirmationPageElements =
      _.map(confirmationPage.getElementsByType('lp-pom-block'), function(section) {
        return _toClipboardFormat(section, clipboardData, editor);
      });

  // Add lightboxes
  } else if (_internalLightboxesEnabled(elm.page) && elm.model.linksToInternalLightbox()) {
    var pageRefId = elm.model.safeGet('action.lightboxId');

    // Add the lightbox, along with its elements, to the clipboardData. We only do this if
    // the lightbox isn't already stored in clipboardData, to prevent a recursion loop.
    if (pageRefId && ! clipboardData.lightboxes[pageRefId]) {
      var lightboxPage = editor.findPageByRefId(pageRefId);

      // Since mobile lightboxes are fixed to a width of 320, we can just copy the
      // desktop width
      clipboardData.lightboxes[pageRefId] = {
        name  : lightboxPage.name,
        width : lightboxPage.getRootElement().model.get('geometry.contentWidth',
          lightboxPage.getBreakpointByName('desktop'))
      };

      clipboardData.lightboxes[pageRefId].elements =
        _.map(lightboxPage.getElementsByType('lp-pom-block'), function(section) {
          return _toClipboardFormat(section, clipboardData, editor);
        });
    }
  }

  return jso;
};

function ElementCopyPaste(editor) {
  this.editor = editor;
  this.newAssets = null;
  this.pastingInProgress = false;

  _.bindAll(this);
}

/* TODO
 The prototype contains quite a few methods which can just be standalone functions and dont need to be part of the prototype
 The context of the current instance can be avoided in quite a few of them
 */
ElementCopyPaste.prototype = {
  _donePasting: function() {
    this.editor.controls.paste.setLabel('Paste');
    this.editor.controls.paste.stopPulse();

    this.editor.page.undoManager.endGroup();
    this.pastingInProgress = false;
  },

  _startPasting: function(pasteData, targetContainer) {
    // Called only after all validation checks have passed to initiate the actual paste

    this.editor.controls.paste.setLabel('Pasting...');
    this.editor.controls.paste.pulse(250, 0.75);
    this.pastingInProgress = true;

    if (! this.editor.page.undoManager.group) {
      // Start an undo group now, unless we already started one when replacing a form.
      // The group will be ended in the _donePasting method.
      this.editor.page.undoManager.startGroup();
    }

    if (_internalLightboxesEnabled(this.editor.page)) {
      this._createLightboxes(pasteData);
    }

    fontMigrator.migrateFontsFromPasteData(pasteData.copiedJSO);

    if (pasteData.companyId !== this.editor.currentCompanyId && pasteData.assetUUIDs.length > 0) {
      // Copy assets to current company before pasting the element
      this._copyAssets(pasteData.assetUUIDs, pasteData.copiedJSO, targetContainer);
    } else {
      this._pasteAndInsertElement(pasteData.copiedJSO, targetContainer);
      this._donePasting();
    }
  },

  _createLightboxes: function(pasteData) {
    // Creates lightbox subpages and creates a map of pasteData page refIDs to created
    // page refIDs
    var self = this;

    this.lightboxIdMap = _.mapValues(pasteData.lightboxes, function(lightboxPasteData) {
      var newLightbox = lightboxFactory.createLightbox(self.editor, {
        name: lightboxPasteData.name,
        size: {
          width: lightboxPasteData.width
        }
      });
      self.editor.addPage(newLightbox);

      return newLightbox.getRefId();
    });

    // This is done as a separate step because _addChildrenToParentElement needs to have
    // the lightboxIdMap defined, so lightbox buttons on lightboxes can be mapped properly
    _.each(pasteData.lightboxes, function(lightboxPasteData, oldRefId) {
      var newRefId     = self.lightboxIdMap[oldRefId];
      var lightboxPage = self.editor.findPageByRefId(newRefId);

      self._addElementsToSubPage(lightboxPasteData.elements, lightboxPage);
    });
  },

  _recreateElementFromJSO: function(jso, container, page0) {
    var page = page0 || this.editor.page;
    jso.id = jso.type + '-' + page.getNextElementId();
    var storageItemModule = lp.getModule(jso.type);

    // Ensure that the newly "created" element has an explicitly set containerId
    jso.containerId = container.id;

    if (jso.type === 'lp-multi-select') {
      return storageItemModule.createElement(page, {
        offset: jso.geometry.offset,
        size: jso.geometry.size,
        parentElement: container
      });

    } else {
      jso.geometry.zIndex = container.getNextZIndex();
      this._rewriteButtonLightboxId(jso, page);

      return storageItemModule.createElement(page, jso);
    }
  },

  _rewriteButtonLightboxId: function(elementJSO, page) {
    // If the element is linked to an internal lightbox, update its model with the correct
    // lightbox refID
    if (_safeGet(elementJSO, 'action.type') === 'internalLightbox') {
      var oldRefId = _safeGet(elementJSO, 'action.lightboxId');
      var newRefId = (this.lightboxIdMap && this.lightboxIdMap[oldRefId]) || oldRefId;

      if (newRefId === page.getRefId()) {
        // If a lightbox button is being pasted onto the same lightbox that it points to,
        // remove the lightbox ID.
        delete elementJSO.action.lightboxId;
      } else {
        elementJSO.action.lightboxId = newRefId;
      }
    }
  },

  _addChildrenToParentElement: function(childElementsJSO, parentElement, page0) {
    // jshint maxcomplexity:42
    var self = this;
    var page = page0 || this.editor.page;

    return _.map(childElementsJSO, function(currentElementJSO) {
      var container =
        currentElementJSO.type === 'lp-pom-block' ? page.getRootElement() : parentElement;

      if ( ! page.isFormConfirmation() && currentElementJSO.type === 'lp-pom-button' && // jscs:ignore disallowSpacesInsideParentheses
          currentElementJSO.action && currentElementJSO.action.type === 'download') {
        // If pasting a button with a file asset into the main page, delete the asset data.
        delete currentElementJSO.action.asset;
        currentElementJSO.action.type = 'url';
        currentElementJSO.action.url = '';
      }

      if (self.newAssets) {
        // If new assets exist we are pasting into a different client. Update model data.
        self._updateAssetData(currentElementJSO);
      }

      var newChildElement = self._recreateElementFromJSO(currentElementJSO, container, page);

      if (newChildElement.type === 'lp-pom-form') {
        self._insertCopiedForm(newChildElement, parentElement, page);

      } else if (newChildElement.type === 'lp-pom-block') {
        page.insertElement(newChildElement, {
          container                     : container,
          containerIndex                : newChildElement.model.jso.sectionIndex,
          dontActivateOnInsert          : true,
          dontUpdateElementTreeOnInsert : true
        });

        //Delete the sectionIndex created to store section placement
        delete newChildElement.model.jso.sectionIndex;

      } else {
        page.insertElement(newChildElement, {
          container                     : container,
          dontActivateOnInsert          : true,
          dontUpdateElementTreeOnInsert : true
        });
      }

      if (currentElementJSO.children) {
        self._addChildrenToParentElement(currentElementJSO.children, newChildElement, page);

        if (newChildElement.type === 'lp-pom-form') {
          // Reattach form button to form.
          newChildElement.model.set('content.buttonId', newChildElement.childElements[0].id);
          newChildElement.createDependantElements();
        }

        // Delete the children array created when the element was copied.
        delete newChildElement.model.modelData.children;
      }

      return newChildElement;
    });
  },

  _insertCopiedForm: function(formElement, parentElement, page) {
    if (this.editor.anyPageHasForm()) {
      this.editor.getFormElementOnAnyPage().removeFromPage();
    }

    page.insertElement(formElement, {
      container                     : parentElement,
      dontActivateOnInsert          : true,
      dontUpdateElementTreeOnInsert : true
    });

    var confirmationPage = formElement.createConfirmationPage();

    this._addElementsToSubPage(formElement.model.modelData.confirmationPageElements, confirmationPage);

    //Delete the model data created when the confirmation elements were copied
    delete formElement.model.modelData.confirmationPageElements;
  },

  _addElementsToSubPage: function(elements, page) {
    var pageSections = page.getElementsByType('lp-pom-block');
    var lastSection  = pageSections[pageSections.length - 1];

    this._addChildrenToParentElement(elements, lastSection, page);
    lastSection.removeFromPage();
  },

  _getSectionVisibleIndex: function(target0) {
    if (target0.type === 'lp-pom-root') {
      var pageSections = target0.getChildElements();

      if (pageSections.length === 0) {
        return 0;
      }
      return pageSections.length;

    } else if (target0.type === 'lp-pom-block') {
      return this.editor.page.getRootElement().getChildElements().indexOf(target0);

    } else {
      return this._getSectionVisibleIndex(target0.getParentElement());
    }
  },

  _findTargetContainerForPaste: function(target0, pasteJSO) {
    if (target0.type === 'lp-pom-root' && pasteJSO.type !== 'lp-pom-block') {
      var pageSections = target0.getVisibleChildElements();

      if (pageSections.length === 0) {
        //If no page sections exist on page, one will be created
        var newSection = lp.getModule('lp-pom-block')
              .addNewElementToPage(window.editor.page, {container:window.editor.page.getRootElement()});

        if (pasteJSO.geometry.size.height > 200) {
          newSection.model.setHeight(pasteJSO.geometry.size.height + 20);
        }

        return newSection;
      } else {
        return pageSections[0];
      }

    } else if (target0.type === 'lp-pom-root' && pasteJSO.type === 'lp-pom-block') {
      return this.editor.page.getRootElement();

    } else if (target0.type === 'lp-pom-box' || target0.type === 'lp-pom-block') {
      return target0;

    } else {
      return this._findTargetContainerForPaste(target0.getParentElement(), pasteJSO);
    }
  },

  _findAvailibleOffsetWithinElement: function(currentOffset, targetContainer, breakpoint) {
    if (targetContainer.childElements.length === 0) {
      return currentOffset;
    }

    for (var i = 0; i < targetContainer.childElements.length; i++) {
      var childElm = targetContainer.childElements[i];
      var elmOffset = childElm.model.jso.geometry.offset;

      if (breakpoint === 'mobile' && childElm.model.jso.breakpoints.mobile.geometry.offset) {
        elmOffset = childElm.model.jso.breakpoints.mobile.geometry.offset;
      }

      if (elmOffset.left === currentOffset.left && elmOffset.top === currentOffset.top) {
        return this._findAvailibleOffsetWithinElement({left:currentOffset.left + 10, top:currentOffset.top + 10}, targetContainer, breakpoint);
      }
    }

    return currentOffset;
  },

  isElemCopyable: function(element) {
    return element !== null && element.type !== 'lp-pom-root' && typeof element !== 'undefined';
  },

  _getNewAssetData: function(oldAsset) {
    var newAsset = this.newAssets[oldAsset.uuid];

    if (newAsset) {
      for (var key in oldAsset) {
        var newAssetValue = newAsset[key];

        if (newAssetValue) {
          oldAsset[key] = newAssetValue;
        }
      }
    }

    return oldAsset;
  },

  _updateAssetData: function(jso) {
    // jshint maxcomplexity:15
    if (jso.type === 'lp-pom-image') {
      jso.content.asset = this._getNewAssetData(jso.content.asset);

    } else if (jso.type === 'lp-pom-box' || jso.type === 'lp-pom-text' || jso.type === 'lp-pom-block') {
      if (_safeGet(jso, 'style.background.image.uuid')) {
        jso.style.background.image = this._getNewAssetData(jso.style.background.image);
      }
      if (_safeGet(jso, 'breakpoints.mobile.style.background.image.uuid')) {
        jso.breakpoints.mobile.style.background.image = this._getNewAssetData(jso.breakpoints.mobile.style.background.image);
      }

    } else if (jso.type === 'lp-pom-button') {
      if (_safeGet(jso, 'style.up.image.uuid')) {
        jso.style.up.image = this._getNewAssetData(jso.style.up.image);
      }
      if (_safeGet(jso, 'style.hover.image.uuid')) {
        jso.style.hover.image = this._getNewAssetData(jso.style.hover.image);
      }
      if (_safeGet(jso, 'style.active.image.uuid')) {
        jso.style.active.image = this._getNewAssetData(jso.style.active.image);
      }

      if (_safeGet(jso, 'breakpoints.mobile.style.up.image.uuid')) {
        jso.breakpoints.mobile.style.up.image = this._getNewAssetData(jso.breakpoints.mobile.style.up.image);
      }
      if (_safeGet(jso, 'breakpoints.mobile.style.hover.image.uuid')) {
        jso.breakpoints.mobile.style.hover.image = this._getNewAssetData(jso.breakpoints.mobile.style.hover.image);
      }
      if (_safeGet(jso, 'breakpoints.mobile.style.active.image.uuid')) {
        jso.breakpoints.mobile.style.active.image = this._getNewAssetData(jso.breakpoints.mobile.style.active.image);
      }

      if (_safeGet(jso, 'action.asset.uuid')) {
        jso.action.asset = this._getNewAssetData(jso.action.asset);
      }
    }
  },

  _copyAssets: function(assets, storageJSO, targetContainer) {
    var postBodyString = assets.collect(function(asset) {
      return 'assets[]=' + asset;
    }).join('&');

    var self = this;
    var url = endpoints.copyAssetsFromAnotherCompany(this.editor.currentCompanyId);

    return new Ajax.Request(url, {
      method: 'post',
      postBody: postBodyString,
      onSuccess: function(transport) {
        self.newAssets = transport.responseJSON;
        self._pasteAndInsertElement(storageJSO, targetContainer);
        self._donePasting();
      },
      onFailure: function() {
        new AlertDialog({
          title   : 'Pasting Failed',
          message : 'An error occurred while copying assets. Please try again or ' +
            'contact support if the problem persists.',
          icon    : 'error'
        }).safeOpen();
        self._donePasting();
      }
    });
  },

  _pasteAndInsertElement: function(storageJSO, targetContainer) {
    var mainElement;

    var _handleNewBGFitWidthToPage = function(storageJSO) {
      var bgTypes = ['solidColor', 'gradient', 'image', 'pattern'];

      storageJSO.breakpoints.mobile.style = storageJSO.breakpoints.mobile.style || {};
      storageJSO.breakpoints.mobile.style.newBackground = storageJSO.breakpoints.mobile.style.newBackground || {};

      _.each(bgTypes, function(type){
        if(storageJSO.style && storageJSO.style.newBackground && storageJSO.style.newBackground[type]) {
          storageJSO.style.newBackground[type].fitWidthToPage = false;
        }

        var mobileStyles = storageJSO.breakpoints.mobile.style.newBackground;

        if(mobileStyles[type]) {
          mobileStyles[type].fitWidthToPage = false;
        }
      });
    };

    if (storageJSO.type === 'lp-pom-block') {
      storageJSO.sectionIndex = this._getSectionVisibleIndex(targetContainer);

      if(targetContainer.page && (targetContainer.page.isLightbox() || targetContainer.page.isFormConfirmation())) {
        // Don't allow page sections to stretch in lightboxes.
        storageJSO.geometry.fitWidthToPage = false;
        storageJSO.geometry.margin.bottom = 0;

        // Handle mobile
        storageJSO.breakpoints.mobile = storageJSO.breakpoints.mobile || {};
        storageJSO.breakpoints.mobile.geometry = storageJSO.breakpoints.mobile.geometry || {};
        storageJSO.breakpoints.mobile.geometry.fitWidthToPage = false;

        _handleNewBGFitWidthToPage(storageJSO);

      }
    }

    if (storageJSO.type === 'lp-multi-select') {
      mainElement = this._recreateElementFromJSO(storageJSO, targetContainer, this.editor.page);

      this._setNewMultiSelectOffsets(storageJSO.children, targetContainer);

      var childrenElms = this._addChildrenToParentElement(storageJSO.children, targetContainer, this.editor.page);

      //Delete the children array created when the element was copied
      delete mainElement.model.modelData.children;

      childrenElms.forEach(function(child) {
        mainElement.addToSelection(child);
      });

    } else {

      var elmOffset = {left: 10, top: 10};

      if (storageJSO.type === 'lp-pom-block') {
        elmOffset = {left: 0, top: 0};
      } else {
        elmOffset = this._findAvailibleOffsetWithinElement(elmOffset, targetContainer);
      }

      storageJSO.geometry.offset = elmOffset;
      storageJSO.breakpoints.mobile.geometry.offset = elmOffset;
      var elements = this._addChildrenToParentElement([storageJSO], targetContainer, this.editor.page);

      if (elements) {
        mainElement = elements[0];
      } else {
        return;
      }
    }

    if ( ! targetContainer.isVisibleOnPage() || ! mainElement.isVisibleOnPage()) { // jscs:ignore disallowSpacesInsideParentheses
      this.editor.page.updateAndRefresh(mainElement);
    }

    mainElement.updateElementTreeOnInsert = true;
    this.editor.setActiveElement(mainElement);
    this.editor.fireEvent('elementPasted', mainElement);

    return mainElement;
  },

  isElemAvailableToPaste: function(targetContainer) {
    return (targetContainer !== null && this._hasPasteItem());
  },

  _getPasteItem: function() {
    return localStorage.getItem('unbounceClipboard');
  },

  _hasPasteItem: function() {
    return  _.size(this._getPasteItem()) > 0;
  },

  pasteElementFromClipboard: function() {
    var self = this;
    var pasteData = JSON.parse(this._getPasteItem());

    if (this.pastingInProgress && ! pasteData.source) {
      return;
    }

    var storageJSO      = pasteData.copiedJSO;
    var targetContainer = this._findTargetContainerForPaste(this.editor.activeElement, storageJSO);

    if ( ! this.isElemAvailableToPaste(targetContainer)) { // jscs:ignore disallowSpacesInsideParentheses
      return;
    }

    this.newAssets = null;

    var pastingIntoSameVariant = this._pastingIntoSameVariant(pasteData);

    jQuery(window).trigger({
      type        : 'contentPasted',
      sameSession : pasteData.source.sessionID === lp.getSessionId(),
      samePage    : pastingIntoSameVariant
    });

    // If we are pasting lightboxes from the same variant, check if they still exist.
    // If so, remove them from the list of lightboxes to be created.
    if (pastingIntoSameVariant) {
      pasteData.lightboxes =
        _.omit(pasteData.lightboxes, function(lightbox, pasteDataRefId) {
          return Boolean(self.editor.findPageByRefId(parseInt(pasteDataRefId, 10)));
        });
    }

    this._validatePaste(pasteData, targetContainer);
  },

  _pastingIntoSameSession: function(pasteData) {
    return pasteData.source && pasteData.source.sessionID === lp.getSessionId();
  },

  _pastingIntoSameVariant: function(pasteData) {
    return pasteData.source && pasteData.source.variantID === this.editor.mainPage.id;
  },

  _pasteDataContainsForm: function(pasteData) {
    var elmHasForm = function(elm) {
      return elm.type === 'lp-pom-form' ||
        (elm.children && _.any(elm.children, elmHasForm));
    };

    var lightboxHasForm = function(lightboxes) {
      return _(lightboxes)
        .map(function(lightbox) {
          return _.any(lightbox.elements, elmHasForm);
        })
        .any();
    };

    return elmHasForm(pasteData.copiedJSO) || lightboxHasForm(pasteData.lightboxes);
  },

  _renderFormPasteAlert: function(pasteData, targetContainer) {
    var extraProps;
    var formPasteMessage;
    var pageName = this.editor.getFormElementOnAnyPage().page.getUsedAsText();

    if (_internalLightboxesEnabled(this.editor.page) &&
      ! ubBanzai.features.isUseEditorUndoStackEnabled()) {
      // Ask the user to remove the form first. The reason for this is because
      // the old undo manager only works per page and undoing accross multiple pages
      // may cause multiple form confirmation dialogs.
      formPasteMessage = [
        "Please remove the form on ",
        "'", pageName, "'",
        " and then paste after the previous form has been deleted."].join('');
    } else { // do the old thing
      formPasteMessage = [
        'Would you like to replace your current form and form confirmation dialog ',
        'with this version?'].join('');

      extraProps = {
        confirmLabel     : 'Yes, replace the form',
        showCancelButton : true,
        onConfirm        : this._startPasting.bind(this, pasteData, targetContainer)
      };
    }

    var alertOptions = {
      title: 'Pasting a Form',
      message: 'It looks like you already have a form on ' + pageName + '.',
      secondaryMessage: formPasteMessage,
      icon : 'error'
    };

    return new AlertDialog(_.merge({}, alertOptions, extraProps));
  },

  _validatePaste: function(pasteData, targetContainer) {
    // This method calls startPasting if all validation checks pass.

    if (_internalLightboxesEnabled(this.editor.page) &&
        this._pasteWouldExceedLightboxLimit(pasteData.lightboxes)) {

      var lightboxCount = _.keys(pasteData.lightboxes).length;

      var message = [
        "Uh-oh! You're trying to paste",
        (lightboxCount > 1 ? lightboxCount + 'lightboxes' : 'a lightbox'),
        "which would exceed the amount of lightboxes allowed on this page."
      ].join(' ');

      new AlertDialog({
        title: 'Pasting Lightboxes',
        message: message,
        secondaryMessage: 'If there are lightboxes on this page that you are not using, first try ' +
         'deleting them and pasting again.',
        icon: 'error'
      }).safeOpen();
      return;
    }

    const module = lp.getModule(pasteData.copiedJSO.type);

    // We don't check for forms here so the below logic can handle them
    if (this.editor.page.isModuleAtLimit(module) && module.type !== 'lp-pom-form') {
      // TODO: Update the copy for this alert dialog
      new AlertDialog({
        title: 'Pasting a ' + module.name,
        message: 'It looks like you are trying to paste a ' + module.name + '.',
        secondaryMessage: 'You have reached your limit of ' + module.name +'s for a ' + this.editor.page.getUsedAsText(),
        icon: 'error'
      }).safeOpen();
      return;
    }

    var pasteDataContainsForm = this._pasteDataContainsForm(pasteData);

    if (pasteDataContainsForm && this.editor.page.isFormConfirmation()) {
      new AlertDialog({
        title: 'Pasting a Form',
        message: 'It looks like you are trying to paste a form into the form confirmation dialog.',
        secondaryMessage: 'This can only be done within the main page or a lightbox.',
        icon: 'error'
      }).safeOpen();
      return;
    }

    if (pasteDataContainsForm && this.editor.anyPageHasForm()) {
      var alertBox = this._renderFormPasteAlert(pasteData, targetContainer);
      alertBox.safeOpen();
      return;
    }

    this._startPasting(pasteData, targetContainer);
  },

  _pasteWouldExceedLightboxLimit: function(lightboxes) {
    return (_.keys(lightboxes).length + this.editor.findPagesUsedAs('lightbox').length) >
      ubBanzai.getFeatureValue('lightboxLimit');
  },

  _setNewMultiSelectOffsets: function(multiJSO, targetContainer) {
    var multiSelectCornerPoints = this._getCornerPointOfMultiSelectedElements(multiJSO);

    var newOffset = {left: 10, top: 10};

    var adjustmentOffset = {};
    adjustmentOffset.desktop = {
      left: newOffset.left - (multiSelectCornerPoints.desktop.left),
      top: newOffset.top - (multiSelectCornerPoints.desktop.top)
    };
    adjustmentOffset.mobile = {
      left: newOffset.left - (multiSelectCornerPoints.mobile.left),
      top: newOffset.top - (multiSelectCornerPoints.mobile.top)
    };

    for (var i = 0; i < multiJSO.length; i++) {
      var elmJSO = multiJSO[i];

      elmJSO.geometry.offset = {
        left: elmJSO.geometry.offset.left + adjustmentOffset.desktop.left,
        top: elmJSO.geometry.offset.top + adjustmentOffset.desktop.top
      };

      elmJSO.geometry.offset = this._findAvailibleOffsetWithinElement(elmJSO.geometry.offset, targetContainer);

      if ( ! elmJSO.breakpoints.mobile.geometry.offset) { // jscs:ignore disallowSpacesInsideParentheses
        elmJSO.breakpoints.mobile.geometry.offset = elmJSO.geometry.offset;
      }

      elmJSO.breakpoints.mobile.geometry.offset = {
        left: elmJSO.breakpoints.mobile.geometry.offset.left + adjustmentOffset.mobile.left,
        top: elmJSO.breakpoints.mobile.geometry.offset.top + adjustmentOffset.mobile.top
      };

      elmJSO.breakpoints.mobile.geometry.offset = this._findAvailibleOffsetWithinElement(elmJSO.breakpoints.mobile.geometry.offset, targetContainer, 'mobile');
    }
  },

  _getCornerPointOfMultiSelectedElements: function(multiJSO) {
    var mostLeftOffset = null;
    var mostTopOffset = null;
    var mostLeftOffsetMobile = null;
    var mostTopOffsetMobile = null;

    for (var i = 0; i < multiJSO.length; i++) {
      var elmJSO = multiJSO[i];

      // jscs:disable disallowSpacesInsideParentheses

      if ( ! elmJSO.breakpoints.mobile.geometry.offset) {
        elmJSO.breakpoints.mobile.geometry.offset = elmJSO.geometry.offset;
      }

      if ( ! mostLeftOffset) {
        mostLeftOffset = elmJSO.geometry.offset.left;
      }

      if ( ! mostTopOffset) {
        mostTopOffset = elmJSO.geometry.offset.top;
      }

      if ( ! mostLeftOffsetMobile) {
        mostLeftOffsetMobile = elmJSO.breakpoints.mobile.geometry.offset.left;
      }

      if ( ! mostTopOffsetMobile) {
        mostTopOffsetMobile = elmJSO.breakpoints.mobile.geometry.offset.top;
      }
      // jscs:enable

      if (elmJSO.geometry.offset.left < mostLeftOffset) {
        mostLeftOffset = elmJSO.geometry.offset.left;
      }

      if (elmJSO.geometry.offset.top < mostTopOffset) {
        mostTopOffset = elmJSO.geometry.offset.top;
      }

      if (elmJSO.breakpoints.mobile.geometry.offset.left < mostLeftOffsetMobile) {
        mostLeftOffsetMobile = elmJSO.breakpoints.mobile.geometry.offset.left;
      }

      if (elmJSO.breakpoints.mobile.geometry.offset.top < mostTopOffsetMobile) {
        mostTopOffsetMobile = elmJSO.breakpoints.mobile.geometry.offset.top;
      }
    }

    var cornerPoints = {};
    cornerPoints.desktop = {left: mostLeftOffset, top: mostTopOffset};
    cornerPoints.mobile = {left: mostLeftOffsetMobile, top: mostTopOffsetMobile};

    return cornerPoints;
  },

  copyElementToClipboard: function() {
    var elementToCopy = this.editor.activeElement;

    if (elementToCopy.type === 'lp-pom-button' && elementToCopy.getParentElement().type === 'lp-pom-form') {
      elementToCopy = elementToCopy.getParentElement();
      this.editor.setActiveElement(elementToCopy);
    }

    if ( ! this.isElemCopyable(elementToCopy)) { // jscs:ignore disallowSpacesInsideParentheses
      return;
    }

    jQuery(window).trigger('contentCopied');

    var clipboardData = {
      assetUUIDs: [],
      lightboxes: {},
      companyId: this.editor.currentCompanyId,
      source: {
        variantID : this.editor.mainPage.id,
        sessionID : lp.getSessionId()
      }
    };

    // This recurses through elements and their children, serializes them, and builds up
    // `assetUUIDs` and `lightboxes` properties
    clipboardData.copiedJSO  = _toClipboardFormat(elementToCopy, clipboardData, this.editor);

    // Remove duplicate asset UUIDs
    clipboardData.assetUUIDs = _.uniq(clipboardData.assetUUIDs);

    localStorage.setItem('unbounceClipboard', JSON.stringify(clipboardData));

    this.editor.controls.copy.setLabel('Copied!');
    this.editor.controls.copy.pulse(500, 0.75, 1200);
  }
};

module.exports = ElementCopyPaste;



// WEBPACK FOOTER //
// ./src/ui/element_copy_paste.js